import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { Autoplay, Navigation, Thumbs, Keyboard } from 'swiper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectGallery',
  props: {
  images: {
    type: Array,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const modules = [Autoplay, Navigation, Thumbs, Keyboard]

const thumbsSwiper = ref(null)

const swiperActiveIndex = ref(0)

const swiperInstance = ref(null)

const onSlideChange = (event) => {
  swiperActiveIndex.value = event.activeIndex
}
const onSwiperReady = (swiper) => {
  swiperInstance.value = swiper
}

// const setThumbsSwiper = (swiper: any) => {
//   thumbsSwiper.value = swiper
// }

const breakpoints = {
  320: {
    spaceBetween: 10,
  },
  1440: {
    spaceBetween: 30,
  },
}

const __returned__ = { props, modules, thumbsSwiper, swiperActiveIndex, swiperInstance, onSlideChange, onSwiperReady, breakpoints, ref, get Autoplay() { return Autoplay }, get Navigation() { return Navigation }, get Thumbs() { return Thumbs }, get Keyboard() { return Keyboard } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})